import { render, staticRenderFns } from "./projects_dropdown.vue?vue&type=template&id=42817608&"
import script from "./projects_dropdown.vue?vue&type=script&lang=js&"
export * from "./projects_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports